import { Injectable } from "@angular/core";

import { CustomFormControl } from "digital-core";

@Injectable({
  providedIn: "root"
})
export class CreditCardValidator {
  constructor() {}

  isCCValid(component: CustomFormControl) {
    if (!component.value) {
      return;
    }
  

    const value = component.value;

    const visaMatch = value.match(/^4[0-9]{12}(?:[0-9]{3})?$/);

    const masterCardMatch = value.match(
      /(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}$/
    );

    if (
      (visaMatch && visaMatch.length > 0) ||
      (masterCardMatch && masterCardMatch.length > 0)
    ) {
      return null;
    } else {
      return { validateCCNumber: { valid: false } };
    }
  }
}
